import moment from 'moment'

const DEV = require('./dev-constants')

export const { PUBLIC_URL } = process.env

export const API_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : DEV.API_URL
export const WORDPRESS_URL = 'https://ventury-analytics.de'
export const RELEASE_VERSION = 'v1.0.83'
export const GIT_SHA = process.env.REACT_APP_GIT_SHA
export const DEBUG_MODE = false

export const INFO_EMAIL = 'info@ventury-analytics.com'
export const SUPPORT_EMAIL = 'support@ventury-analytics.de'

export const IS_PRODUCTION = ['https://app.ventury-analytics.de'].includes(window.location.origin)
export const IS_STAGING = ['https://dev.ventury-analytics.de'].includes(window.location.origin)
export const GOOGLE_TRACKING_ID = IS_PRODUCTION ? 'UA-141916558-1' : 'UA-141916558-4'

console.log(`Version ${RELEASE_VERSION} ${IS_PRODUCTION ? 'Production' : 'Development'}`)

export const ENABLE_WEBSOCKETS = false
export const MAX_RETY_ON_QUERY_ERROR = 5

// Open Graph API
export const OPEN_GRAPH_API = 'https://opengraph.io/api/1.1/site/'
export const OPEN_GRAPH_API_APP_ID = 'app_id=0a46d5da-5129-4f45-a58f-2b3bb5088a86'

// CUSTOM FILE LINKS
export const EXCEL_TEMPLATE_SHAREHOLDER = (isDE) =>
  `https://storage.googleapis.com/ventury-extra-items/stakeholder_import_template_${
    isDE ? 'de' : 'en'
  }.xlsx`
export const COMPANY_IMG_PLACEHOLDER =
  'https://storage.googleapis.com/ventury-extra-items/company-logo-placeholder.png'
export const FEEDBACK_FORM_LINK =
  'https://form.asana.com?k=G3HtvUs_3maFiCulhtQcow&d=1198216002545763'
export const CONSULTING_REQUEST_LINK = 'https://meetings.hubspot.com/merlin3'

// ACCESS RIGHTS CONSTANTS
export const DEFAULT_ROLES = {
  projectRoles: ['SUPPORT', 'OWNER', 'ADMIN', 'EDITOR', 'VIEWER'],
}

export const PROJECT_ROLE_EDITOR = ['EDITOR', 'ADMIN', 'OWNER', 'SUPPORT']
export const MULT_PROJECTS_ORGS = ['BUSINESS_ANGEL', 'SERVICE_PROVIDER', 'ENTERPRISE']

export const FREE_EARLY_STAGE_AMOUNT = 1000000
export const AGB_NEEDS_AGREEMENT = moment()
  .subtract(1, 'months')
  .isBefore(moment('20210214', 'YYYYMMDD'))
export const GRUENDERPLATFORM_MIGRATION = false
export const GRUENDERPLATFORM_ACCOUNT_CREATION_URL =
  'https://gruenderplattform.de/api/equity/legacy-user.json'

// TREE RENDER PROPERTIES
export const TREE = {
  MODES: {
    EXPAND: 'Expand',
    PROJECT: 'Project',
    TEMPLATE: 'Template',
    TREETOOLS: ['Treetools', 'Mark', 'super-delete', 'super-add', 'super-edit'],
    // FILTER: 'Filter',
    // MARK: 'Mark',

    TREETYPE: 'TreeType',
    // COLLAPSE: 'Collapse',
    COMPARE: 'Compare',
    REFRESH: 'Refresh',

    DELETE: 'Delete',

    ADDNODE: 'super-add',
    EDITNODE: 'super-edit',
    DELETENODE: 'super-delete',
  },
  SPACING: {
    x: 200,
    y: 10,
  },
  NODE: {
    W: 130,
    H: 90,
    BOX: 20,
    PADDING: 5,
    SCALE: 1.15,
    R: 3,
    SELECT: 15,
  },
}

export const MAX_NUMBER = Number.MAX_SAFE_INTEGER
